// eslint-disable-next-line no-restricted-syntax
export enum AppLocale {
  en = 'en',
  fr = 'fr',
  es = 'es',
}
